module.exports = __webpack_public_path__ + "static/media/activity_filled.552ef554.png";